var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasAlarmOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "219.23pt",
    height: "328.68pt",
    viewBox: "-106 0 219.23 328.68",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.625
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.415 292.41h-77.241c-10.063 0-19.465 2.8418-27.588-1.8652v12.898c0 9.1431 7.4121 16.553 16.553 16.553h99.309c9.1431 0 16.553-7.4097 16.553-16.553v-12.898c-8.1226 4.707-17.522 1.8652-27.585 1.8652z",
    fill: "#0b1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.897 0h-66.208c-6.0864 0.01709-11.016 4.9487-11.033 11.035v60.964c1.8213-0.16602 3.6401-0.27588 5.5176-0.27588h77.241c1.875 0 3.6963 0.10986 5.5176 0.27588v-60.964c-0.01953-6.0864-4.9487-11.018-11.035-11.035zm-11.035 38.621c0 3.0469-2.4707 5.5176-5.5176 5.5176h-33.103c-3.0469 0-5.5176-2.4707-5.5176-5.5176v-11.035c0-3.0469 2.4707-5.5176 5.5176-5.5176h33.103c3.0469 0 5.5176 2.4707 5.5176 5.5176z",
    fill: "#3771c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-50.827 66.206h77.241c30.471 0 55.171 24.702 55.171 55.173v121.38c0 30.471-24.7 55.173-55.171 55.173h-77.241c-30.471 0-55.173-24.702-55.173-55.173v-121.38c0-30.471 24.702-55.173 55.173-55.173z",
    fill: "#008080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-12.206 248.28c-11.035 0-44.138-2.0923-44.138-33.484 0.49805-10.356 5.0562-20.1 12.688-27.119 0.10254-0.0928 0.25635-0.10986 0.37598-0.0391 0.11963 0.0708 0.17822 0.21484 0.14404 0.34912-1.1816 3.4546-3.9502 14.25 8.8281 14.25 4.4141 0 8.8257-2.0898 8.8257-10.481 0-8.3936-11.033-16.746-11.033-29.304 0-13.926 8.3252-33.655 24.275-35.569 0.28076-0.0439 0.5542 0.10743 0.6665 0.36866 0.10986 0.26123 0.0293 0.56396-0.19775 0.73486-4.0601 2.4658-6.687 6.7334-7.0557 11.47 0 25.115 50.759 33.484 50.759 75.339 0 31.392-33.105 33.484-44.138 33.484z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.33686 0 0 .33686 -98.443 96.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m395.8 160.1c-3.3-38.7-35.4-68.099-74.7-68.099h-130.2c-39.3 0-71.4 29.399-74.7 68.099l-26.7 291.9h333z",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.5 452h-166.5v-360h65.1c39.3 0 71.4 29.399 74.7 68.099z",
    fill: "#f03800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 227,
    width: 30,
    height: 150,
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 227,
    width: 15,
    height: 150,
    fill: "#f03800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    width: 30,
    height: 60,
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.88 1 420.87 16 390.81 68.061 364.82 53.061",
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.4999 .8661 -.8661 .4999 363.6 -332.46)",
    x: 454.69,
    y: 116.08,
    width: 30.005,
    height: 65.082,
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.12 1 147.18 53.061 121.19 68.061 91.132 16",
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.8661 .4999 -.4999 .8661 79.961 -1.2476)",
    x: 9.767,
    y: 133.62,
    width: 65.083,
    height: 30.005,
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 210.2-75-37.5v168.6l75-37.5 75 37.5v-168.6z",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 362,
    width: 210,
    height: 75,
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 15,
    height: 60,
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256 210.2 331 172.7 331 341.3 256 303.8",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 362,
    width: 105,
    height: 75,
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.001,
    y: 422,
    width: 390,
    height: 90,
    fill: "#575f64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 422,
    width: 195,
    height: 90,
    fill: "#32393f"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.19513 0 0 .19513 13.321 232.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m451.27 136.27c-2.7969-0.5039-4.9336-2.7773-5.1523-5.6094-5.6367-72.82-66.504-130.16-140.77-130.16-54.746 0-102.21 31.164-125.64 76.715-1.3633 2.6523-4.4102 3.9727-7.2656 3.1055-6.7812-2.0547-13.977-3.168-21.43-3.168-33.734 0-62.176 22.605-71.039 53.488-0.76562 2.668-3.2383 4.4375-6.0117 4.4375h-0.05078c-41.148 0-74.441 33.625-73.906 74.898 0.52734 40.617 34.387 72.934 75.008 72.934h361.97c40.992 0 75.348-33.543 75.012-74.531-0.29297-36.051-26.391-65.93-60.727-72.113z",
    fill: "#54a0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.01 77.148c7.457 0 14.648 1.1172 21.434 3.1719 2.8555 0.86719 5.8984-0.45703 7.2656-3.1055 20.824-40.492 60.648-69.594 107.7-75.562-5.9102-0.75781-11.934-1.1523-18.051-1.1523-54.75 0-102.21 31.164-125.64 76.715-0.0586 0.11328-0.14063 0.21484-0.20703 0.32812 2.4688-0.25 4.9688-0.39453 7.5039-0.39453z",
    fill: "#338def"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 209.97c-0.53516-41.273 32.762-74.898 73.91-74.898h0.0508c2.7695 4e-3 5.2461-1.7695 6.0078-4.4336 7.2305-25.191 27.484-44.867 53.008-51.27-5.75-1.4414-11.762-2.2227-17.961-2.2227-33.734 0-62.176 22.605-71.039 53.492-0.76562 2.6641-3.2383 4.4375-6.0117 4.4336h-0.04687c-41.148 0-74.445 33.625-73.91 74.898 0.52734 40.621 34.387 72.934 75.012 72.934h35.992c-40.625 0-74.484-32.312-75.012-72.934z",
    fill: "#338def"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e4eaf8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.67 390.71h-66.469c-4.2695 0-7.7266-3.4609-7.7266-7.7266 0-4.2695 3.457-7.7266 7.7266-7.7266h58.742v-63.703c0-4.2695 3.4609-7.7305 7.7266-7.7305 4.2656 0 7.7266 3.4609 7.7266 7.7305v71.43c0 4.2656-3.4609 7.7266-7.7266 7.7266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.54 461.77c-4.2656 0-7.7266-3.4609-7.7266-7.7305v-142.48c0-4.2695 3.457-7.7266 7.7266-7.7266 4.2656 0 7.7266 3.457 7.7266 7.7266v142.48c0 4.2695-3.4609 7.7305-7.7266 7.7305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.61 390.71h-66.473c-4.2656 0-7.7266-3.4609-7.7266-7.7266v-71.43c0-4.2695 3.4609-7.7305 7.7266-7.7305 4.2695 0 7.7305 3.4609 7.7305 7.7305v63.703h58.742c4.2656 0 7.7266 3.457 7.7266 7.7266 0 4.2656-3.4609 7.7266-7.7266 7.7266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.27 461.77c-4.2656 0-7.7266-3.4609-7.7266-7.7305v-142.48c0-4.2695 3.4609-7.7266 7.7266-7.7266 4.2695 0 7.7305 3.457 7.7305 7.7266v142.48c0 4.2695-3.4609 7.7305-7.7305 7.7305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.67 257.78c-4.2656 0-7.7266-3.4609-7.7266-7.7266v-11.461c0-4.2656 3.4609-7.7266 7.7266-7.7266 4.2656 0 7.7266 3.457 7.7266 7.7266v11.461c0 4.2656-3.4609 7.7266-7.7266 7.7266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.54 257.78c-4.2656 0-7.7266-3.4609-7.7266-7.7266v-11.461c0-4.2656 3.457-7.7266 7.7266-7.7266 4.2656 0 7.7266 3.457 7.7266 7.7266v11.461c0 4.2656-3.4609 7.7266-7.7266 7.7266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.27 257.78c-4.2656 0-7.7266-3.4609-7.7266-7.7266v-11.461c0-4.2656 3.4609-7.7266 7.7266-7.7266 4.2695 0 7.7305 3.457 7.7305 7.7266v11.461c0 4.2656-3.4609 7.7266-7.7305 7.7266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.14 257.78c-4.2656 0-7.7266-3.4609-7.7266-7.7266v-11.461c0-4.2656 3.4609-7.7266 7.7266-7.7266 4.2695 0 7.7305 3.457 7.7305 7.7266v11.461c0 4.2656-3.4609 7.7266-7.7305 7.7266z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m83.203 382.99c0 10.496-8.5117 19.004-19.008 19.004-10.496 0-19.004-8.5078-19.004-19.004 0-10.5 8.5078-19.008 19.004-19.008 10.496 0 19.008 8.5078 19.008 19.008z",
    fill: "#feca57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.945 382.99c0-5.5234 2.3711-10.477 6.1289-13.953-3.3867-3.1289-7.9023-5.0547-12.879-5.0547-10.496 0-19.004 8.5078-19.004 19.004 0 10.5 8.5078 19.008 19.004 19.008 4.9766 0 9.4922-1.9258 12.879-5.0586-3.7617-3.4688-6.1289-8.4258-6.1289-13.945z",
    fill: "#f4b537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.55 473.05c0 10.496-8.5117 19.008-19.008 19.008-10.496 0-19.004-8.5117-19.004-19.008 0-10.496 8.5078-19.004 19.004-19.004 10.496 0 19.008 8.5078 19.008 19.004z",
    fill: "#feca57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.29 473.05c0-5.5195 2.3672-10.477 6.1289-13.949-3.3906-3.1289-7.9023-5.0586-12.879-5.0586-10.496 0-19.008 8.5117-19.008 19.008 0 10.496 8.5117 19.008 19.008 19.008 4.9766 0 9.4922-1.9297 12.879-5.0586-3.7617-3.4726-6.1289-8.4258-6.1289-13.949z",
    fill: "#f4b537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.27 473.05c0 10.496-8.5078 19.008-19.008 19.008-10.496 0-19.004-8.5117-19.004-19.008 0-10.496 8.5078-19.004 19.004-19.004 10.5 0 19.008 8.5078 19.008 19.004z",
    fill: "#feca57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.02 473.05c0-5.5195 2.3711-10.477 6.1289-13.949-3.3867-3.1289-7.9023-5.0586-12.879-5.0586-10.496 0-19.004 8.5117-19.004 19.008 0 10.496 8.5078 19.008 19.004 19.008 4.9766 0 9.4922-1.9297 12.879-5.0586-3.7578-3.4726-6.1289-8.4258-6.1289-13.949z",
    fill: "#f4b537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.62 382.99c0 10.496-8.5117 19.004-19.008 19.004s-19.004-8.5078-19.004-19.004c0-10.5 8.5078-19.008 19.004-19.008s19.008 8.5078 19.008 19.008z",
    fill: "#feca57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.36 382.99c0-5.5234 2.3711-10.477 6.1289-13.953-3.3867-3.1289-7.9024-5.0547-12.879-5.0547-10.496 0-19.004 8.5078-19.004 19.004 0 10.5 8.5078 19.008 19.004 19.008 4.9766 0 9.4922-1.9258 12.879-5.0586-3.7578-3.4688-6.1289-8.4258-6.1289-13.945z",
    fill: "#f4b537"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasAlarmOnline);
export default __webpack_public_path__ + "static/media/gas_alarm_online.bc1d439d2fad8e502665f7567eaf2235.svg";
export { ForwardRef as ReactComponent };